import '.bn{flex-shrink:0;}.ssr-plugin'
import '.bp{padding:1rem;}.ssr-plugin'
import '.a8{width:100%;}.ssr-plugin'
import '.bk{height:100%;}.ssr-plugin'
import '.ax{border:none;}.ssr-plugin'
import '.ay{background-color:transparent;}.ssr-plugin'
import '.fq{border-radius:0px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.e{flex-direction:column;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.d8{position:sticky;}.ssr-plugin'
import '.fr{top:4rem;}.ssr-plugin'
import '.fs{z-index:7;}.ssr-plugin'
import '.ae{background-color:var(--shades-white);}.ssr-plugin'
import '.ft{padding-bottom:1rem;}.ssr-plugin'
import '.v{margin-bottom:1rem;}.ssr-plugin'
import '.fu{border-bottom:var(--blue-border);}.ssr-plugin'
import '.a3{position:fixed;}.ssr-plugin'
import '.cg{top:0;}.ssr-plugin'
import '.bi{left:0px;}.ssr-plugin'
import '.bj{right:0px;}.ssr-plugin'
import '.fv{bottom:0px;}.ssr-plugin'
import '.eo{z-index:9999;}.ssr-plugin'
import '.fw{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.cz{justify-content:flex-end;}.ssr-plugin'
import '.bu{flex:1;}.ssr-plugin'
import '.at{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="bn bp a8 bk ax ay fq"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="a e ab"
    >
      <div className="d8 fr fs ae ft v fu a"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="a3 cg bi bj fv eo ae fw a e"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="bp a cz fu"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="bu at">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
